import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { LoginRequest } from '../../../../domain/user.model';
import { UserAction } from '../../store/user.action';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];
    hasError = false;
    request = new LoginRequest();

    constructor(private store: Store,
                private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(state => state.user.error)
                .subscribe(hasError => this.hasError = hasError)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


    login() {
        const url = this.route.snapshot.queryParams.link;
        this.store.dispatch(new UserAction.Login(this.request, url));
    }

}
